import * as React from "react";
import i18n from "../../../i18n/i18n";
import classNames from "classnames";
import IErrorVm from "../../../models/home/Error/IErrorVm";

interface IAcceptTermsAndConditionsComponentProps {
  areTermsAndConditionsAccepted: boolean;
  validationErrors: IErrorVm[];
  onUpdateAreTermsAndConditionsAccepted: (value: boolean) => void;
}

export default class AcceptTermsAndConditionsComponent extends React.Component<IAcceptTermsAndConditionsComponentProps> {
  public render(): JSX.Element {
    const { areTermsAndConditionsAccepted, validationErrors, onUpdateAreTermsAndConditionsAccepted } = this.props;

    const alertClassName = classNames({
      alert: true,
      span12: true,
      "alert-info": areTermsAndConditionsAccepted,
      "alert-warning": !areTermsAndConditionsAccepted,
    });

    return (
      <tbody>
        <tr className={alertClassName} style={{ padding: "4px" }}>
          <td style={{ verticalAlign: "top" }}>
            <input id="cbConfirm" type="checkbox" checked={areTermsAndConditionsAccepted} onChange={(e: any) => onUpdateAreTermsAndConditionsAccepted(e.target.checked)} data-ui-test={"confirm-checkbox"} />
          </td>
          <td style={{ padding: 7 }}>
            <label htmlFor="cbConfirm">{i18n.t("TEXT_PAYMENT_CONFIRM_INFORMATION")}</label>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            {validationErrors
              .filter((x) => {
                return x.property === "areTermsAndConditionsAccepted";
              })
              .map((err, i) => {
                return (
                  <p key={i} className="alert alert-error">
                    {err.message}
                  </p>
                );
              })}
          </td>
        </tr>
      </tbody>
    );
  }
}
